<template>
  <div
    class="container"
    :style="{
      top: iosFocusFlag ? '6rem' : '0rem',
      height: iosFocusFlag ? 'calc(100% - 6rem)' : '100%',
    }"
  >
    <van-watermark
      :z-index="1"
      :full-page="true"
      :width="600"
      :height="150"
      :opacity="0.4"
      :gap-x="5"
      :style="{
        width: watermarkWidth,
        marginLeft: watermarkMarginLeft,
        marginLeft: '50px',
      }"
      :content="watermarkContent"
    />
    <header class="header" ref="headerRef">
      <Fold
        class="fold"
        style="width: 0.5rem; height: 0.5rem"
        @click="openLeftMenu"
      ></Fold>
      <span class="title">对话</span>
    </header>
    <div class="top" style="display: none">
      <span
        style="display: none"
        class="ill"
        v-if="(role == 0 || role == 1) && illName"
        >#疾病名称：{{ illName }}</span
      >
      <span class="out" @click="quitLogin">退出登录</span>
    </div>
    <div
      class="containerContent"
      ref="containerContentRef"
      :style="{
        height:
          'calc(100% - env(safe-area-inset-bottom) - ' +
          containerContentHeight +
          'px)',
      }"
    >
      <div class="content-ul" v-if="role == 0 || role == 4">
        <div class="content-ul-li">
          <div class="answer" v-if="multipleInfo.length == 0">
            <div class="answer-con">
              <img src="../../../static/images/logo.png" />
              <div class="anwer">
                {{ startWords }}
              </div>
            </div>
          </div>
          <div
            class="answer"
            style="background: #fff"
            v-if="multipleInfo.length == 0"
          >
            <div
              class="answer-con"
              style="width: calc(100% - 0.4rem); padding-right: 0.4rem"
            >
              <div class="anwer" style="width: 100%">
                <div class="item" style="margin-left: 33px">
                  <span>{{ startWordsTwo }}</span>
                  <el-radio-group
                    v-model="radio"
                    @change="changeRadio"
                    v-show="startWordsTwo.length == 5"
                    disabled
                  >
                    <el-radio :label="0" :disabled="isDisabled ? true : false"
                      >男</el-radio
                    >
                    <el-radio :label="1" :disabled="isDisabled ? true : false"
                      >女</el-radio
                    >
                  </el-radio-group>
                </div>
                <div class="item" style="margin-left: 33px">
                  <span>{{ startWordsThree }}</span>
                  <div
                    v-show="startWordsThree.length == 5"
                    style="display: inline-block"
                  >
                    <!-- <el-date-picker
                      id="datePicker"
                      v-model="date"
                      type="date"
                      placeholder="选择或填写日期,如YYYY-XX-ZZ"
                      @change="changeDate"
                      :editable="true"
                      :disabled="isDisabled ? true : false"
                    >
                    </el-date-picker> -->
                    <el-date-picker
                      id="datePicker"
                      v-model="date"
                      type="date"
                      placeholder="选择或填写日期,如YYYY-XX-ZZ"
                      @change="changeDate"
                      :editable="true"
                      disabled
                    >
                    </el-date-picker>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="answer" v-if="multipleInfo.length > 0">
            <div class="answer-con">
              <img src="../../../static/images/logo.png" />
              <div class="anwer" v-if="role == 4">
                {{ startWordsOther }}
              </div>
              <div class="anwer" v-else>
                {{ startWordsOtherRole0 }}
              </div>
            </div>
          </div>
          <div
            class="answer"
            style="background: #fff"
            v-if="multipleInfo.length > 0"
          >
            <div
              class="answer-con"
              style="width: calc(100% - 0.4rem); padding-right: 0.4rem"
            >
              <div class="anwer" style="width: 100%">
                <div class="item" style="margin-left: 33px">
                  <span>{{ startWordsTwoOther }}</span>
                  <el-radio-group v-model="radio" @change="changeRadio">
                    <el-radio :label="0" :disabled="isDisabled ? true : false"
                      >男</el-radio
                    >
                    <el-radio :label="1" :disabled="isDisabled ? true : false"
                      >女</el-radio
                    >
                  </el-radio-group>
                </div>
                <div class="item" style="margin-left: 33px">
                  <span>{{ startWordsThreeOther }}</span>
                  <el-date-picker
                    v-model="date"
                    type="date"
                    placeholder="选择或填写日期,如YYYY-XX-ZZ"
                    @change="changeDate"
                    :editable="true"
                    :disabled="isDisabled ? true : false"
                  >
                  </el-date-picker>
                </div>
              </div>
            </div>
          </div>
          <div class="problem" style="display: none" v-if="role == 0">
            <div class="problem-con">
              <img
                v-if="userInfo.avatar"
                :src="globalImgPath + userInfo.avatar"
              />
              <img v-else src="../../../static/images/touxiang.png " />
              <span class="anwer" v-if="!illName">
                <el-select
                  v-model="illValue"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入您的疾病名称"
                  :remote-method="remoteMethod"
                  :loading="loading"
                  no-data-text="暂无数据"
                >
                  <el-option
                    v-for="item in searchIllList"
                    :key="item.id"
                    :label="item.illName"
                    :value="item.illName"
                  >
                  </el-option>
                </el-select>

                <el-button
                  class="sure"
                  type="primary"
                  style="margin-left: 10px"
                  @click="sureIll"
                  >确定</el-button
                >
              </span>
              <span v-else>
                {{ illName }}
              </span>
            </div>
          </div>
          <div class="answer" v-if="illName">
            <div class="answer-con">
              <img
                v-if="role == 0"
                style="margin-top: 12px"
                src="../../../static/images/logo.png"
              />
              <div class="anwer" v-if="role == 0">
                <p>请问你现在有什么症状？该症状出现多长时间了？</p>
                <p>沟通时说明年龄、性别，可有助于得到更为准确的判断哦！</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="content-ul"
        style="display: none"
        v-if="role == 1 && multipleInfo.length > 0 && !isMultipleInfoFlag"
      >
        <div
          class="content-ul-li"
          v-for="(item, index) in multipleInfo"
          :key="index"
        >
          <div class="answer" v-if="index < 3">
            <div class="answer-con">
              <img src="../../../static/images/logo.png" />

              <div
                class="anwer"
                v-loading="item.loading"
                element-loading-text="拼命加载中"
              >
                {{ item.content }}
              </div>
            </div>
          </div>

          <div
            class="problem"
            v-if="role == 1 && multipleInfoFlag && index == 0"
          >
            <div class="problem-con" v-if="!illName">
              <img
                v-if="userInfo.avatar"
                :src="globalImgPath + userInfo.avatar"
              />
              <img v-else src="../../../static/images/touxiang.png " />
              <span class="anwer" v-if="!illName">
                <el-select
                  v-model="illValue"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入您的疾病名称"
                  :remote-method="remoteMethod"
                  :loading="loading"
                  no-data-text="暂无数据"
                >
                  <el-option
                    v-for="item in searchIllList"
                    :key="item.id"
                    :label="item.illName"
                    :value="item.illName"
                  >
                  </el-option>
                </el-select>

                <el-button
                  class="sure"
                  type="primary"
                  style="margin-left: 10px"
                  @click="sureIll"
                  >确定</el-button
                >
              </span>
            </div>
          </div>

          <div class="problem" v-if="role == 1 && illName && item.answer">
            <div class="problem-con">
              <img
                v-if="userInfo.avatar"
                :src="globalImgPath + userInfo.avatar"
              />
              <img v-else src="../../../static/images/touxiang.png " />
              <span class="anwer">{{ item.answer }}</span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="content-ul"
        v-if="(role == 0 || role == 4) && multipleInfo.length > 0"
      >
        <div
          class="content-ul-li"
          v-for="(item, index) in multipleInfo"
          :key="index"
        >
          <div class="answer" v-if="index < 2">
            <div class="answer-con">
              <img src="../../../static/images/logo.png" />

              <div
                class="anwer"
                v-loading="item.loading"
                element-loading-text="拼命加载中"
              >
                {{ item.content }}
              </div>
            </div>
          </div>
          <div class="problem" v-if="index < 3 && item.answer">
            <div class="problem-con">
              <img
                v-if="userInfo.avatar"
                :src="globalImgPath + userInfo.avatar"
              />
              <img v-else src="../../../static/images/touxiang.png " />
              <span class="anwer">{{ item.answer }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="content-ul" v-if="conversationDetailList.length > 0">
        <div
          class="content-ul-li"
          v-for="(item, index) in conversationDetailList"
          :key="index"
        >
          <div
            class="problem"
            :class="(role == 0 || role == 4) && index == 0 ? 'multiple' : ''"
            v-if="item.questionStatus == 1"
          >
            <div class="problem-con">
              <img
                v-if="userInfo.avatar"
                :src="globalImgPath + userInfo.avatar"
              />
              <img v-else src="../../../static/images/touxiang.png " />
              <span class="anwer">
                <span
                  class="multipleSpan"
                  v-if="(role == 0 || role == 4) && index == 0"
                >
                </span>
                <span v-else>
                  {{ item.question }}
                </span>
              </span>
            </div>
          </div>
          <div class="answer">
            <div class="answer-con" v-if="index == 0">
              <img src="../../../static/images/logo.png" />

              <div
                class="anwer"
                v-loading="item.loading"
                element-loading-text="拼命加载中"
                v-html="item.answer"
              ></div>
            </div>
            <div class="answer-con" v-if="index == 1 && showAnswerEnding">
              <div class="anwer anwerEnding">
                {{ item.answer }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom" ref="bottomRef">
      <div class="tips" style="display: none">
        <div
          class="left"
          :style="{ cursor: enteringFlag ? 'not-allowed' : 'pointer' }"
          @click="answerAgain"
        >
          <img src="../../../static/images/oncemore.png" />
          再答一次
        </div>
        <div
          class="left"
          :style="{ cursor: enteringFlag ? 'not-allowed' : 'pointer' }"
          @click="exportExcel"
        >
          <img src="../../../static/images/excel.png" />
          导出excel
        </div>
      </div>
      <!-- <div class="chart-input" v-show="!enteringFlag">
				<el-input ref="chartValRef" resize="none" :autosize="{ minRows:2, maxRows:2}" type="textarea"
					placeholder="在此提问，(按Shift+Enter 键可换行)" v-model="chartVal" @keydown="Keydown">
				</el-input>
				<el-button type="primary" :icon="Promotion" @click="send">发送</el-button>
			</div> -->
      <div class="chart-input" v-show="!enteringFlag">
        <el-input
          style="display: none"
          v-if="chartInputReadOnlyFlag == false"
          ref="chartValRef"
          resize="none"
          :disabled="chartInputReadOnlyFlag"
          :autosize="{ minRows: 2, maxRows: 5 }"
          type="textarea"
          :placeholder="
            chartInputReadOnlyFlag ? '本轮对话已结束，请新建对话，再次问诊' : ''
          "
          v-model="chartVal"
          @keydown="Keydown"
          @focus="iosFocus"
          @blur="iosBlur"
          @input="iosInput"
        >
        </el-input>
        <el-input
          v-if="chartInputReadOnlyFlag == false"
          readonly
          ref="chartValRef"
          resize="none"
          :disabled="chartInputReadOnlyFlag"
          :autosize="{ minRows: 2, maxRows: 5 }"
          type="textarea"
          :placeholder="
            chartInputReadOnlyFlag ? '本轮对话已结束，请新建对话，再次问诊' : ''
          "
          v-model="chartVal"
          @click="clickDisable"
        >
        </el-input>
        <el-button
          style="display: none"
          v-if="chartInputReadOnlyFlag == false"
          type="primary"
          :icon="Promotion"
          @click="send"
          >发送
        </el-button>
        <el-button
          v-if="chartInputReadOnlyFlag == false"
          type="primary"
          :icon="Promotion"
          @click="clickDisable"
          >发送
        </el-button>
        <!-- <div  v-if="chartInputReadOnlyFlag" class="chart-input-btn" @click="createNewConversation(0)">
					新建对话
				</div> -->
        <div v-if="chartInputReadOnlyFlag" class="chart-input-div">
          <el-button
            :icon="Plus"
            class="chart-input-btn"
            @click="createNewConversation(0)"
          >
            新建对话</el-button
          >
        </div>
      </div>
      <div
        class="chart-input"
        id="elInput"
        v-show="enteringFlag && showInput"
        :class="showGantanhao ? 'gantanhaoInput' : ''"
      >
        <el-input
          resize="none"
          readonly
          :autosize="{ minRows: 2, maxRows: 2 }"
          type="textarea"
          :placeholder="placeholder"
          v-model="chartVal"
          @keydown="Keydown"
          @click="clickInput"
          style="display: none"
        >
        </el-input>
        <el-input
          resize="none"
          readonly
          :autosize="{ minRows: 2, maxRows: 2 }"
          type="textarea"
          :placeholder="placeholder"
          v-model="chartVal"
          @click="clickDisable"
        >
        </el-input>
        <div class="gantanhao" v-if="showGantanhao" id="gantanhao">
          <img src="../../../static/images/gantanhao.png" alt="" />
        </div>
        <el-button
          type="primary"
          id="breakOff"
          @click="breakOff"
          style="display: none"
        >
          <img src="../../../static/images/zhongzhi.png" />
          中止
        </el-button>
        <el-button type="primary" id="breakOff" @click="clickDisable">
          <img src="../../../static/images/zhongzhi.png" />
          中止
        </el-button>
      </div>
    </div>

    <el-dialog
      title="请预先选择疾病分类："
      v-model="multipleDialogueFlag"
      width="380px"
      align-center
    >
      <div class="login-content single">
        <ul>
          <li
            v-for="(item, index) in multipleIllList"
            :key="index"
            @click="goMultipleChart(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </el-dialog>
    <el-dialog
      title="请预先选择疾病分类："
      v-model="singleDialogueFlag"
      width="380px"
      align-center
    >
      <div class="login-content">
        <ul>
          <li
            v-for="(item, index) in singleIllList"
            :key="index"
            @click="goSingleChart(item)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
    </el-dialog>
    <el-dialog title="提示：" v-model="dialogDisable" width="80%" align-center>
      <div class="login-content single disableMsg">
        因公司业务战略调整，本大模型产品自2025年03月18日起暂停服务。我们将在条件成熟时带着升级优化的功能与体验回归，感谢您的支持，期待再次为您服务！
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { Plus, Promotion, Fold } from "@element-plus/icons-vue";
import {
  ref,
  reactive,
  toRefs,
  getCurrentInstance,
  onMounted,
  //defineProps,
  onBeforeUnmount,
  defineEmits,
  defineExpose,
  nextTick,
  watch,
  // watchEffect,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
const containerContentRef = ref(null);

const route = useRoute();
const router = useRouter();
const uniHttp = getCurrentInstance().appContext.config.globalProperties;
const globalImgPath = uniHttp.globalImgPath;
const chartValRef = ref(null);
const bottomRef = ref(null);
const headerRef = ref(null);
const emit = defineEmits([
  "getEnteringFlag",
  "getRole",
  "getConversateList",
  "openLeftMenu",
]);
const data = reactive({
  dialogDisable: false,
  showAnswerEnding: false,
  datePicker: null,
  showInput: true,
  showGantanhao: false,
  isDisabled: false,
  placeholder: "请耐心等待小经医生把话说完…",
  startWords: "",
  startWordsTwo: "",
  startWordsThree: "",
  startWordsOther:
    "您好，我是小经医生，为方便给您推荐个性化的养生方案，请先填写您的个人基本信息。",
  startWordsOtherRole0: "您好，我是小经医生，请先认真填选您的基本信息。",
  startWordsTwoOther: "用户性别:",
  startWordsThreeOther: "出生日期:",
  radio: NaN,
  gender: "",
  date: "",
  dateTwo: "",
  role: 0,
  chartVal: "",
  answer: "",
  firstId: "",
  conversationDetailAddRes: {},
  conversationDetail: {},
  conversationDetailList: [],
  question: "",
  conversationID: "",
  enteringFlag: false,
  enteringTimer: null,
  editAnser: "", //编辑答案,
  illName: "",
  multipleDialogueFlag: false,
  singleDialogueFlag: false,
  singleIllList: [
    {
      name: "冠心病心绞痛",
      id: 0,
    },
    {
      name: "痛经",
      id: 1,
    },
  ],
  multipleIllList: [
    {
      name: "胃脘痛",
      id: 0,
    },
  ],
  illValue: "",
  loading: false,
  illList: [],
  searchIllList: [],
  userInfo: {},
  multipleInfo: [], //知病多轮
  multipleInfoFlag: false,
  resultFlag: false,
  isMultipleInfoFlag: false,
  chartInputReadOnlyFlag: false,
  watermarkContent: "",
  watermarkWidth: "100%",
  watermarkMarginLeft: 0,
  scollVal: 0,
  iosFocusFlag: false,
  containerContentHeight: 0,
});

//使用toRefs解构
const {
  dialogDisable,
  showAnswerEnding,
  showInput,
  showGantanhao,
  isDisabled,
  placeholder,
  startWords,
  startWordsTwo,
  startWordsThree,
  startWordsOther,
  startWordsOtherRole0,
  startWordsTwoOther,
  startWordsThreeOther,
  radio,
  date,
  role,
  chartVal,
  conversationDetailList,
  enteringFlag,
  illName,
  multipleDialogueFlag,
  singleDialogueFlag,
  multipleIllList,
  singleIllList,
  illValue,
  loading,
  searchIllList,
  userInfo,
  multipleInfo,
  multipleInfoFlag,
  isMultipleInfoFlag,
  chartInputReadOnlyFlag,
  watermarkContent,
  watermarkWidth,
  watermarkMarginLeft,
  iosFocusFlag,
  containerContentHeight,
} = toRefs(data);

/* const props = defineProps({
		conversationDetail: {
			type: Object,
			default: NaN,
		}
	}) */

//关闭左侧菜单
const colseLeftMenu = () => {
  data.watermarkWidth = "calc(100%)";
  data.watermarkMarginLeft = "0rem";
};
defineExpose({
  colseLeftMenu,
});

watch([placeholder, date], (newValue) => {
  if (newValue[0] == "请先填写性别、出生日期等资料信息") {
    data.showGantanhao = true;
  } else {
    data.showGantanhao = false;
  }
  if (newValue[1]) {
    data.datePicker.blur();
  }
});
/*
// 监听聚焦事件
watchEffect(() => {
  nextTick(() => {
    const datePicker = document.getElementById("datePicker");
    datePicker.addEventListener("focus", () => {
      data.showInput = false;
    });
  });
});
// 监听失焦事件
watchEffect(() => {
  nextTick(() => {
    const datePicker = document.getElementById("datePicker");
    datePicker.addEventListener("blur", () => {
      data.showInput = true;
    });
  });
});
*/

const clickDisable = () => {
  data.dialogDisable = true;
};

//未填写资料时点击事件
const clickInput = () => {
  if (data.placeholder == "请先填写性别、出生日期等资料信息") {
    data.showGantanhao = true;
    shakeInput();
  }
};
//输入框抖动
const shakeInput = () => {
  setTimeout(() => {
    const elInput = document.getElementById("elInput");
    const gantanhao = document.getElementById("gantanhao");
    const breakOff = document.getElementById("breakOff");
    elInput.classList.add("shake");
    gantanhao.classList.add("gantanhaoShake");
    breakOff.classList.add("gantanhaoShake");
    setTimeout(() => {
      elInput.classList.remove("shake");
      gantanhao.classList.remove("gantanhaoShake");
      breakOff.classList.remove("gantanhaoShake");
    }, 300);
  }, 100);
};
//选择性别
const changeRadio = () => {
  if (data.radio == 0) {
    data.gender = "男";
  }
  if (data.radio == 1) {
    data.gender = "女";
  }
  if (data.gender && data.date) {
    let answer = "用户性别:" + data.gender + "\n" + "出生日期:" + data.dateTwo;
    getQuestionNext(data.firstId, answer);
  }
};
//选择日期
const changeDate = () => {
  const time = new Date(data.date);
  const year = time.getFullYear();
  const month = time.getMonth() + 1;
  const day = time.getDate();
  data.dateTwo = year + "-" + month + "-" + day;
  if (data.gender && data.date) {
    let answer = "用户性别:" + data.gender + "\n" + "出生日期:" + data.dateTwo;
    getQuestionNext(data.firstId, answer);
  }
};
//文字动态效果
const outPuting = () => {
  data.enteringFlag = true;
  let str = "";
  if (data.role == "4") {
    str =
      "您好，我是小经医生，为方便给您推荐个性化的养生方案，请先填写您的个人基本信息。";
  }
  if (data.role == "0") {
    str = "您好，我是小经医生，请先认真填选您的基本信息。";
  }

  let start = 0;
  let enteringTimer = setInterval(() => {
    data.startWords += str.substr(start, 1);
    start++;
    if (start == str.length) {
      clearInterval(enteringTimer);
      outPutingTwo();
    }
  }, 50);
};
//文字动态效果
const outPutingTwo = () => {
  let strTwo = "用户性别:";
  let startTwo = 0;
  let enteringTimerTwo = setInterval(() => {
    data.startWordsTwo += strTwo.substr(startTwo, 1);
    startTwo++;
    if (startTwo == strTwo.length) {
      clearInterval(enteringTimerTwo);
      outPutingThree();
    }
  }, 50);
};
//文字动态效果
const outPutingThree = () => {
  let strThree = "出生日期:";
  let startThree = 0;
  let enteringTimerThree = setInterval(() => {
    data.startWordsThree += strThree.substr(startThree, 1);
    startThree++;
    if (startThree == strThree.length) {
      clearInterval(enteringTimerThree);
    }
  }, 50);
  if (data.gender && data.date) {
    data.placeholder = "请耐心等待小经医生把话说完…";
  } else {
    data.placeholder = "请先填写性别、出生日期等资料信息";
  }
};
//获取用户信息
const getUserInfo = () => {
  uniHttp
    .$applicationJson("business/user/info")
    .then((res) => {
      if (res.data.code == 0) {
        data.userInfo = res.data.data; //获取用户信息更新头像和昵称
        data.watermarkContent =
          data.userInfo.name +
          " " +
          data.userInfo.phone +
          " " +
          "AI生成内容仅供参考";
      } else {
        if (res.status != 203 && res.status != 205) {
          ElMessage({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      }
    })
    .catch((Error) => {
      console.log(Error);
    });
  //data.conversationDetail = props.conversationDetail;
  data.role = window.localStorage.getItem("role");
  data.conversationID = route.query.conversationId;
  if (data.role == 0 || data.role == 4) {
    getQuestionNextFour();
    outPuting();
    if (data.startWordsThree.length == 5) {
      data.enteringFlag = false;
    }
  }
  data.illName = route.query.illName;
  if (route.query.question) {
    data.question = route.query.question;
  }
  if (data.question && data.question != "") {
    conversationDetailAdd(data.question, 1);
  }
  if (data.role == 0 || data.role == 1 || data.role == 4) {
    getQuestionList();
  } else {
    getConversationDetail();
  }

  emit("getRole", data.role);
  emit("getConversateList", data.conversationID); //触发conversationId的变化 更新父组件
};

const openLeftMenu = () => {
  emit("openLeftMenu", true);
  data.watermarkWidth = "20%";
  data.watermarkMarginLeft = "80%";
};
//获取性别和出生日期
const getGenderAndDate = (str) => {
  let arr = str.split("\n");
  data.gender = arr[0].split(":")[1];
  data.dateTwo = arr[1].split(":")[1];
  if (data.gender == "男") {
    data.radio = 0;
  }
  if (data.gender == "女") {
    data.radio = 1;
  }
  data.date = data.dateTwo;
};

//获取报告
const getQuestionList = () => {
  uniHttp
    .$applicationJson("business/question/list", {
      id: data.conversationID,
    })
    .then((res) => {
      if (res.data.code == 0) {
        if (res.data.data.length == 0) {
          data.multipleInfo = [];
          data.isMultipleInfoFlag = false;
        } else {
          getConversationDetail();
          data.isMultipleInfoFlag = true;
          if (data.role == 0 || data.role == 4) {
            let length = res.data.data.length;
            data.multipleInfo = res.data.data.splice(1, length - 1);
            if (length > 1) {
              getGenderAndDate(res.data.data[0].answer);
              data.isDisabled = true;
            } else {
              data.isDisabled = false;
            }
          } else {
            data.multipleInfo = res.data.data;
          }
        }
      } else {
        if (res.status != 203 && res.status != 205) {
          ElMessage({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      }
    })
    .catch((Error) => {
      console.log(Error);
    });
};
//获取role=4时第一个问题的id
const getQuestionNextFour = (id, answer) => {
  uniHttp
    .$applicationJson("business/question/next", {
      conversationId: data.conversationID,
      id: id,
      answer: answer,
      role: 4,
    })
    .then((res) => {
      if (res.data.code == 0) {
        data.firstId = res.data.data.id;
      }
    });
};
//知病多轮---next
const getQuestionNext = (id, answer) => {
  data.placeholder = "请耐心等待小经医生把话说完…";
  const addObj = {
    answer: "",
    content: "",
    conversationId: "",
    id: "",
    result: "",
    loading: true,
  };
  data.multipleInfo.push(addObj);
  data.chartVal = "";
  data.enteringFlag = true;
  uniHttp
    .$applicationJson("business/question/next", {
      conversationId: data.conversationID,
      id: id,
      answer: answer,
      role: data.role,
    })
    .then((res) => {
      if (res.data.code == 0) {
        data.isDisabled = true;
        if (
          res.data.data.answer &&
          !res.data.data.answer.includes("用户性别")
        ) {
          if (data.multipleInfo.length - 1 == 0) {
            data.multipleInfo[data.multipleInfo.length - 1].answer =
              res.data.data.answer;
          } else {
            data.multipleInfo[data.multipleInfo.length - 2].answer =
              res.data.data.answer;
          }
        }

        if (res.data.data.result != null) {
          conversationDetailAdd(res.data.data.result, 1);
          data.resultFlag = true;
          //data.enteringFlag = false;
        } else {
          if (!res.data.data.content.includes("用户性别")) {
            let answer = res.data.data.content;
            let answer2 = res.data.data.content; //.replace(/\n/g,'\r\n')
            res.data.data.content = "";
            let start = 0;
            if (answer2) {
              data.multipleInfo[data.multipleInfo.length - 1].conversationId =
                res.data.data.conversationId;
              data.multipleInfo[data.multipleInfo.length - 1].content =
                res.data.data.content;
              data.multipleInfo[data.multipleInfo.length - 1].id =
                res.data.data.id;
              data.multipleInfo[data.multipleInfo.length - 1].loading = false;
              data.enteringTimer = setInterval(() => {
                data.multipleInfo[data.multipleInfo.length - 1].content +=
                  answer2.substr(start, 1);
                start++;
                nextTick(() => {
                  containerContentRef.value.scrollTo({
                    top: containerContentRef.value.scrollHeight,
                    behavior: "smooth",
                  });
                });
                if (start == answer.length) {
                  clearInterval(data.enteringTimer);
                  data.enteringFlag = false;
                  data.multipleInfoFlag = true;
                  emit("getEnteringFlag", data.enteringFlag); //触发父组件获取标题列表
                  nextTick(() => {
                    //chartValRef.value.focus()
                  });
                }
              }, 50);
            } else {
              data.multipleInfo[data.multipleInfo.length - 1].answer =
                res.data.data.answer;
              data.multipleInfo[data.multipleInfo.length - 1].conversationId =
                res.data.data.conversationId;
              data.multipleInfo[data.multipleInfo.length - 1].content =
                res.data.data.content;
              data.multipleInfo[data.multipleInfo.length - 1].id =
                res.data.data.id;
              data.multipleInfo[data.multipleInfo.length - 1].loading = false;
            }
          }
        }
        // console.log("multipleInfo", data.multipleInfo);
      } else {
        if (res.status != 203 && res.status != 205) {
          ElMessage({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      }
    })
    .catch((Error) => {
      console.log(Error);
    });
};

//获取疾病列表
const getIllList = (query) => {
  uniHttp
    .$applicationJson("business/illness/list", {
      illName: query,
    })
    .then((res) => {
      if (res.data.code == 0) {
        data.searchIllList = res.data.data;
      } else {
        if (res.status != 203 && res.status != 205) {
          ElMessage({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      }
    })
    .catch((Error) => {
      console.log(Error);
    });
};

//远程搜索疾病
const remoteMethod = (query) => {
  if (query !== "") {
    setTimeout(() => {
      getIllList(query);
    }, 200);
  } else {
    data.searchIllList = [];
  }
};

//选择确定疾病
const sureIll = () => {
  if (data.illValue) {
    data.illName = data.illValue;
    data.conversationDetail.title = data.illName;
    conversationTitleEdit(data.illName, data.illName);
    if (data.role == 1) {
      getQuestionNext(data.multipleInfo[0].id, data.illValue, data.illValue);
    }
  } else {
    ElMessage({
      showClose: true,
      message: "请先选择疾病名称",
      type: "info",
    });
  }
};

//键盘事件
const Keydown = (e) => {
  if (!e.shiftKey && e.keyCode == 13) {
    e.cancelBubble = true; //ie阻止冒泡行为
    e.stopPropagation(); //Firefox阻止冒泡行为
    e.preventDefault(); //取消事件的默认动作*换行
    //以下处理发送消息代码
    send();
  }
};

const iosFocus = () => {
  const userAgent =
    typeof window === "object" ? window.navigator.userAgent : "";
  if (!/android/i.test(userAgent)) {
    data.iosFocusFlag = true;
    nextTick(() => {
      containerContentRef.value.scrollTo({
        top: containerContentRef.value.scrollHeight,
        behavior: "smooth",
      });
    });
  }
};
const iosBlur = () => {
  nextTick(() => {
    data.containerContentHeight = Number(
      bottomRef.value.offsetHeight + headerRef.value.offsetHeight * 1.3
    );
  });
  const userAgent =
    typeof window === "object" ? window.navigator.userAgent : "";
  if (!/android/i.test(userAgent)) {
    data.iosFocusFlag = false;
  }
};
const iosInput = () => {
  nextTick(() => {
    data.containerContentHeight = Number(
      bottomRef.value.offsetHeight + headerRef.value.offsetHeight * 1.3
    );
  });
};
//点发送
const send = () => {
  if (data.chartVal) {
    /* */
    getConDetail(data.chartVal);

    if (
      (data.role == 0 || data.role == 1 || data.role == 4) &&
      !data.resultFlag
    ) {
      getQuestionNext(
        data.multipleInfo[data.multipleInfo.length - 1].id,
        data.chartVal,
        data.chartVal
      );
    } else {
      conversationDetailAdd(data.chartVal, 1);
    }
    nextTick(() => {
      data.containerContentHeight = Number(
        bottomRef.value.offsetHeight + headerRef.value.offsetHeight * 1.3
      );
    });
  }
};

//获取会话详情POST /business/conversationDetail/detail
const conversationDetailAdd = (question, questionStatus) => {
  const addObj = {
    answer: "",
    answerStatus: "",
    conversationId: "",
    createTime: "",
    id: "",
    question: question,
    questionStatus: questionStatus,
    role: "",
    loading: true,
  };
  const addObjTwo = {
    answer: "",
  };
  data.conversationDetailList.push(addObj);
  data.conversationDetailList.push(addObjTwo);
  data.chartVal = "";
  route.query.question = "";
  data.enteringFlag = true;
  emit("getEnteringFlag", data.enteringFlag); //机器人正在回答中  触发父组件 不点点击
  uniHttp
    .$applicationJson("business/conversationDetail/add", {
      question: question,
      conversationId: data.conversationID,
      role: data.role,
      answerStatus: 1,
      questionStatus: questionStatus,
    })
    .then((res) => {
      if (res.data.code == 0) {
        setTimeout(() => {
          data.conversationDetailAddRes = res.data.data;
          data.chartInputReadOnlyFlag = true;
          let answer = res.data.data.answer;
          let answer2 = res.data.data.answer; //.replace(/\n/g,'\r\n')
          res.data.data.answer = "";
          let start = 0;
          if (answer2) {
            data.conversationDetailList[0].answer = res.data.data.answer;
            data.conversationDetailList[0].conversationId =
              res.data.data.conversationId;
            data.conversationDetailList[0].answerStatus =
              res.data.data.answerStatus;
            data.conversationDetailList[0].createTime =
              res.data.data.createTime;
            data.conversationDetailList[0].id = res.data.data.id;
            data.conversationDetailList[0].questionStatus =
              res.data.data.questionStatus;
            data.conversationDetailList[0].role = res.data.data.role;
            data.conversationDetailList[0].loading = false;
            //data.conversationDetailList.push(res.data.data)
            data.enteringTimer = setInterval(() => {
              // data.editAnser += answer2.substr(start, 1);
              // data.conversationDetailList[0].answer += answer2.substr(start, 1);
              let curStr = answer2.substr(start, 1);
              if (curStr === "<") {
                let htmlTag = answer2
                  .substr(start)
                  .match(/<[^\u4e00-\u9fa5\d]+>/g)[0];
                curStr = answer2.substr(start, 1 + htmlTag.length);
                start += htmlTag.length;
              }
              data.editAnser += curStr;
              data.conversationDetailList[0].answer += curStr;
              start++;
              nextTick(() => {
                containerContentRef.value.scrollTo({
                  top: containerContentRef.value.scrollHeight,
                  behavior: "smooth",
                });
              });
              // if (start == answer.length) {
              if (
                data.conversationDetailList[0].answer.length == answer.length
              ) {
                clearInterval(data.enteringTimer);
                data.showAnswerEnding = true;
                let start2 = 0;
                let str = "";
                if (data.role == 0) {
                  str =
                    "*本AI输出结果仅供参考，不作为处方的最终依据，用户应根据自身的判断选择部分使用、全部使用或者不使用。";
                }
                if (data.role == 4) {
                  str =
                    "*本AI输出结果仅供参考，不作为您保持身体健康和预防疾病的最终依据，在采取养生措施前，请咨询专业医生或健康专家的意见。";
                }
                let timer = setInterval(() => {
                  data.conversationDetailList[1].answer += str.substr(
                    start2,
                    1
                  );
                  start2++;
                  nextTick(() => {
                    containerContentRef.value.scrollTo({
                      top: containerContentRef.value.scrollHeight,
                      behavior: "smooth",
                    });
                  });
                  if (start2 == str.length) {
                    clearInterval(timer);
                    data.enteringFlag = false;
                    route.query.question = "";
                    data.question = "";
                    data.chartInputReadOnlyFlag = true;
                    emit("getEnteringFlag", data.enteringFlag); //触发父组件获取标题列表
                    nextTick(() => {
                      // chartValRef.value.focus();
                    });
                  }
                }, 50);
              }
            }, 50);
          } else {
            data.conversationDetailList[0].answer = res.data.data.answer;
            data.conversationDetailList[0].conversationId =
              res.data.data.conversationId;
            data.conversationDetailList[0].answerStatus =
              res.data.data.answerStatus;
            data.conversationDetailList[0].createTime =
              res.data.data.createTime;
            data.conversationDetailList[0].id = res.data.data.id;
            data.conversationDetailList[0].questionStatus =
              res.data.data.questionStatus;
            data.conversationDetailList[0].role = res.data.data.role;
            data.conversationDetailList[0].loading = false;
          }
          /* nextTick(() => {
						containerContentRef.value.scrollTo({
							top: containerContentRef.value.scrollHeight,
							behavior: 'smooth'
						});
					}) */
        }, 2000);
      } else {
        data.enteringFlag = false;
        emit("getEnteringFlag", data.enteringFlag); //触发父组件获取标题列表
        if (res.status != 203 && res.status != 205) {
          ElMessage({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      }
    })
    .catch((Error) => {
      data.enteringFlag = false;
      emit("getEnteringFlag", data.enteringFlag); //触发父组件获取标题列表
      console.log(Error);
    });
};

const getConDetail = (name) => {
  uniHttp
    .$applicationJson("business/conversation/detail", {
      id: data.conversationID,
    })
    .then((res) => {
      if (res.data.code == 0) {
        if (!res.data.data.title) {
          let title = name.substr(0, 12);
          conversationTitleEdit(title);
        }
      } else {
        if (res.status != 203 && res.status != 205) {
          ElMessage({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      }
    })
    .catch((Error) => {
      console.log(Error);
    });
};

//修改标题
const conversationTitleEdit = (name, illName) => {
  uniHttp
    .$applicationJson("business/conversation/edit", {
      conversationId: data.conversationID,
      title: name,
      illName: illName,
    })
    .then((res) => {
      if (res.data.code == 0) {
        emit("getRole", data.role);
        data.conversationDetail.title = name;
      } else {
        if (res.status != 203 && res.status != 205) {
          ElMessage({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      }
    })
    .catch((Error) => {
      console.log(Error);
    });
};

//中止
const breakOff = () => {
  if (data.gender && data.date) {
    clearInterval(data.enteringTimer);
    data.enteringFlag = false;
    conversationEdit();
    emit("getEnteringFlag", data.enteringFlag);
  }
  if (data.placeholder == "请先填写性别、出生日期等资料信息") {
    shakeInput();
  }
};

//编辑答案/business/conversationDetail/edit
const conversationEdit = () => {
  uniHttp
    .$applicationJson("business/conversationDetail/edit", {
      answer: data.editAnser,
      id: data.conversationDetailAddRes.id,
    })
    .then((res) => {
      if (res.data.code != 0) {
        if (res.status != 203 && res.status != 205) {
          ElMessage({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      }
    })
    .catch((Error) => {
      console.log(Error);
    });
};

//获取会话详情POST /business/conversationDetail/detail
const getConversationDetail = () => {
  data.conversationDetailList = [];
  uniHttp
    .$applicationJson("business/conversationDetail/detail", {
      current: 0,
      pageSize: 100000,
      params: {
        conversationId: data.conversationID,
        role: data.role,
      },
    })
    .then((res) => {
      if (res.data.code == 0) {
        data.conversationDetailList = res.data.data.records.reverse();
        if (data.conversationDetailList.length > 0) {
          data.resultFlag = true;
          if (data.role == 0 || data.role == 4) {
            data.chartInputReadOnlyFlag = true;
            data.enteringFlag = false;
            getGenderAndDate(data.conversationDetailList[0].question);
          }
          data.isDisabled = true;
          data.showAnswerEnding = true;
          if (data.role == 0) {
            data.conversationDetailList.push({
              answer:
                "*本AI输出结果仅供参考，不作为处方的最终依据，用户应根据自身的判断选择部分使用、全部使用或者不使用。",
            });
          }
          if (data.role == 4) {
            data.conversationDetailList.push({
              answer:
                "*本AI输出结果仅供参考，不作为您保持身体健康和预防疾病的最终依据，在采取养生措施前，请咨询专业医生或健康专家的意见。",
            });
          }
        }

        if (data.conversationDetailList.length == 0) {
          if (data.multipleInfo.length > 0) {
            getQuestionNext(
              data.multipleInfo[data.multipleInfo.length - 1].id,
              data.multipleInfo[data.multipleInfo.length - 1].answer
            );
          }
          data.isDisabled = false;
        }
        for (let i = 0; i < data.conversationDetailList.length; i++) {
          data.conversationDetailList[i].loading = false;
          //data.conversationDetailList[i].answer = data.conversationDetailList[i].answer.replace(/\n/g,"<br/>")
        }
        nextTick(() => {
          containerContentRef.value.scrollTo({
            top: containerContentRef.value.scrollHeight,
            behavior: "smooth",
          });
        });
      } else {
        if (res.status != 203 && res.status != 205) {
          ElMessage({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      }
    })
    .catch((Error) => {
      console.log(Error);
    });
};

//再答一次
const answerAgain = () => {
  if (data.enteringFlag) {
    return false;
  }
  getPreQuestion();
};

//获取上一个问题
const getPreQuestion = () => {
  uniHttp
    .$applicationJson("business/conversationDetail/detail", {
      current: 0,
      pageSize: 10,
      params: {
        conversationId: data.conversationID,
      },
    })
    .then((res) => {
      if (res.data.code == 0) {
        let preQuestion = res.data.data.records[0].question;
        conversationDetailAdd(preQuestion, 0);
      } else {
        if (res.status != 203 && res.status != 205) {
          ElMessage({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      }
    })
    .catch((Error) => {
      console.log(Error);
    });
};

//导出
const exportExcel = () => {
  if (data.enteringFlag) {
    return false;
  }
  exportExcelSure();
};

//导出excel
const exportExcelSure = () => {
  uniHttp
    .$applicationJson(
      "/business/conversationDetail/export/excel",
      {
        id: data.conversationID,
      },
      {
        responseType: "",
      }
    )
    .then((res) => {
      if (res.data.code == 0) {
        downloadFun(res.data.msg);
      } else {
        if (res.status != 203 && res.status != 205) {
          ElMessage({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      }
    })
    .catch((Error) => {
      console.log(Error);
    });
};

//下载Excel
const downloadFun = (val) => {
  console.log(val);
  uniHttp
    .$post(
      "business/download",
      {
        path: "/download/" + val,
      },
      {
        responseType: "blob",
      }
    )
    .then((res) => {
      let fileName = val;
      fileName = data.conversationDetail.title + ".xls";
      let blob = res.data;
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        let url = URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
      }
      return;
    })
    .catch((Error) => {
      console.log(Error);
    });
};

const quitLogin = () => {
  router.push({
    path: "/HelloAvg/HelloAvg",
  });
  window.localStorage.removeItem("GptMToken");
};

//新建聊天
const createNewConversation = () => {
  getList(data.role);
};
//获取标题列表
const getList = (role) => {
  uniHttp
    .$applicationJson("business/conversation/paging", {
      current: 0,
      pageSize: 1000,
      params: {
        role: role,
      },
    })
    .then((res) => {
      if (res.data.code == 0) {
        const chartTitleList = res.data.data.records.reverse();
        if (chartTitleList.length == 0) {
          conversationAdd(role, "", "");
        } else {
          if (
            chartTitleList[0].title == "" ||
            chartTitleList[0].title == null
          ) {
            let conversationId = chartTitleList[0].conversationId;
            router.replace({
              path: "/GptChart/GptChart",
              query: {
                conversationId: conversationId,
                question: "",
                illName: "",
                role: data.role,
              },
            });
          } else {
            conversationAdd(role, "", "");
          }
        }
      } else {
        if (res.status != 203 && res.status != 205) {
          ElMessage({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      }
    })
    .catch((Error) => {
      console.log(Error);
    });
};
//新增标题
const conversationAdd = (role, type, illName) => {
  uniHttp
    .$applicationJson("business/conversation/add", {
      role: data.role,
      illName: illName,
    })
    .then((res) => {
      if (res.data.code == 0) {
        data.conversationDetail = res.data.data;
        data.conversationId = res.data.data.conversationId;
        router.replace({
          path: "/GptChart/GptChart",
          query: {
            conversationId: data.conversationId,
            question: "",
            del: data.role,
            illName: "",
            role: data.role,
          },
        });
      } else {
        if (res.status != 203 && res.status != 205) {
          ElMessage({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      }
    })
    .catch((Error) => {
      console.log(Error);
    });
};

onMounted(() => {
  getUserInfo();
  nextTick(() => {
    data.containerContentHeight = Number(
      bottomRef.value.offsetHeight + headerRef.value.offsetHeight * 1.3
    );
    data.datePicker = document.getElementById("datePicker");
  });
});

onBeforeUnmount(() => {
  clearInterval(data.enteringTimer);
  data.enteringFlag = false;
});
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  background: #fff;
  left: 0;
  top: 0rem;
  overflow-x: hidden;
  position: fixed;
  .disableMsg {
    margin-top: -0.5rem !important;
    text-indent: 2em;
    line-height: 0.5rem;
    text-align: justify;
  }
  /deep/.el-textarea {
    .el-textarea__inner {
      background: #f5f7fa;
    }
  }
  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }
  .gantanhaoShake {
    animation: shake 0.5s;
  }
  /deep/.el-textarea .el-textarea__inner {
    padding-top: 10px !important;
  }
  .shake {
    /deep/.el-textarea .el-textarea__inner {
      padding-left: 35px !important;
      animation: shake 0.5s;
    }
  }
  .gantanhaoInput {
    /deep/.el-textarea .el-textarea__inner {
      padding-left: 35px !important;
    }
  }
  /deep/.el-date-editor {
    --el-date-editor-width: 240px !important;
  }
  /deep/.el-radio {
    margin-top: 2px;
    .el-radio__input {
      width: 16px;
      height: 16px;
    }
    .el-radio__label {
      font-size: 16px;
      color: #2c3e50;
      font-weight: normal;
    }
  }

  .top {
    padding: 25px 0;
    text-align: center;
    margin-right: 30px;
    position: relative;
    overflow: hidden;

    .top-select {
      float: right;
    }

    .ill {
      font-weight: bold;
      display: inline-block;
      height: 30px;
      line-height: 30px;
    }

    .out {
      float: right;
      cursor: pointer;
      border: 1px solid #eee;
      height: 30px;
      line-height: 30px;
      border-radius: 5px;
      padding: 0 20px;
      display: none;
    }
  }

  .center {
    width: 100%;
    text-align: center;
    font-size: 24px;
    font-weight: bold;
    padding: 30px 0;
    margin-top: 100px;

    img {
      width: 300px;
      margin: 0 auto;
    }
  }
  .header {
    height: 1rem;
    line-height: 1rem;
    width: 100%;
    position: absolute;
    text-align: center;
    .fold {
      position: absolute;
      left: 0.2rem;
      top: 0.25rem;
    }
    span {
      width: calc(100%);
      text-align: center;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; // 默认不换行；
      font-size: 0.38rem;
      display: inline-block;
    }
  }
  .containerContent {
    width: 100%;
    height: calc(100% - 2.7rem - env(safe-area-inset-bottom));
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-width: none;
    position: absolute;
    top: 1rem;
    &::-webkit-scrollbar {
      display: none;
    }

    .content-ul {
      width: 100%;
      font-size: 14px;

      .problem {
        width: 100%;
        margin: 0px auto;
        background: #fff;
        overflow: hidden;
        padding: 15px 0px;
        .problem-con {
          width: calc(100% - 0.8rem);
          padding: 0px 0.4rem;
          margin: 0px auto;
          font-size: 0.32rem;
          overflow: hidden;
          img {
            float: left;
            width: 0.48rem;
            margin-right: 0.2rem;
            border-radius: 0.48rem;
          }

          .anwer {
            float: left;
            line-height: 24px;
            width: calc(100% - 40px);
            overflow: hidden;
            .el-button {
              background: #1c3eb9;
              border: 1px solid #1c3eb9;
            }
          }
        }
      }
      .problem.multiple {
        display: none;
        .problem-con {
          img {
            display: none;
          }
        }
        .multipleSpan {
          background: #eee;
        }
      }
      .answer {
        background: #f9f9f9;
        width: 100%;

        .answer-con {
          width: calc(100% - 0.8rem);
          margin: 0px auto;
          padding: 0.3rem 0.4rem;
          overflow: hidden;
          font-size: 0.32rem;
          overflow: hidden;
          /deep/ p {
            margin-bottom: 10px;
            float: left;
            width: 100%;
            span {
              display: inline-block;
              width: calc(100% - 20px);
              float: left;
            }
            .number {
              display: inline-block;
              width: 20px;
            }
            &.yangshengType {
              margin-top: 30px;
            }
          }
          img {
            float: left;
            width: 0.48rem;
            margin-right: 0.2rem;
          }

          .anwer {
            float: left;
            line-height: 24px;
            width: calc(100% - 40px);
            white-space: pre-wrap;
            &.anwerEnding {
              margin-left: 32px;
              font-style: oblique;
              color: #858585;
              font-family: "Courier New", Courier, monospace;
              font-weight: lighter;
            }
            .item {
              &:nth-child(1) {
                // margin-top: -0.1rem;
              }
              &:nth-child(2) {
                margin-top: 0.1rem;
              }
              span {
                margin-right: 5px;
              }
            }
          }
        }
      }
      /deep/ .el-loading-spinner {
        .circular {
          width: 0.4rem;
          height: 0.4rem;
          margin-top: 0.25rem;
        }
        .el-loading-text {
          margin-top: -0.1rem;
        }
      }
      &:nth-child(1) {
        .anwer {
          overflow: hidden;
        }
      }
    }
  }

  .bottom {
    left: 0%;
    right: 0;
    bottom: 0.3rem;
    width: 96%;
    margin: 0px auto;
    min-height: 1.2rem;
    position: absolute;
    padding-bottom: env(safe-area-inset-bottom);
    .tips {
      width: 100%;
      height: 40px;
      line-height: 40px;

      .left {
        float: left;
        text-align: center;
        cursor: pointer;
        margin-right: 20px;
        font-size: 14px;
        line-height: 40px;
        img {
          width: 24px;
          float: left;
          margin-top: 8px;
          margin-right: 5px;
        }
      }
    }

    .chart-input {
      z-index: 9;
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .gantanhao {
        position: absolute;
        left: 10px;
        z-index: 99;
        img {
          width: 22px;
          height: auto;
        }
      }
      .chart-input-div {
        width: 100%;
        margin-top: 0.15rem;
        z-index: 9;
      }

      .el-textarea {
        width: 90%;
        flex: 1;
        border-radius: 5px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.3rem;
        /deep/ .el-textarea__inner {
          min-height: 40px !important;
          padding: 8px 110px 8px 11px;
        }
      }

      .el-button {
        margin-left: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 0.7rem;
        position: absolute;
        right: 10px;
        background: #1c3eb9;
        border: 1px solid #1c3eb9;
        font-size: 0.3rem;
        img {
          width: 12px;
          margin-right: 5px;
        }
      }
      .chart-input-btn {
        width: 90%;
        height: 0.88rem;
        line-height: 0.88rem;
        margin: 0 auto;
        border-radius: 5px;
        text-align: center;
        color: #fff;
        font-size: 0.3rem;
        background: #1c3eb9;
        border: 1px solid #1c3eb9;
        right: 5%;
      }
    }
  }
}
</style>
